import productEnrichmentData from '../data/productEnrichment.json';

/**
 * Get enriched product data by SKU
 * @param {string} sku - The product SKU
 * @returns {object|null} The enriched product data or null if not found
 */
export const getEnrichedProduct = (sku) => {
    if (!sku) return null;
    const enriched = productEnrichmentData[sku];
    if (enriched && enriched.found) {
        return enriched;
    }
    return null;
};

/**
 * Check if enriched data exists for a SKU
 * @param {string} sku - The product SKU
 * @returns {boolean}
 */
export const hasEnrichedData = (sku) => {
    return getEnrichedProduct(sku) !== null;
};
